var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRemoveCircle = function SvgRemoveCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 23
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#9BA5AF",
    fillRule: "evenodd",
    d: "M11.5 23C5.149 23 0 17.851 0 11.5S5.149 0 11.5 0 23 5.149 23 11.5 17.851 23 11.5 23zm-1.213-10H17v-3H6v3h4.287z"
  })));
};
export { SvgRemoveCircle as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMyIgaGVpZ2h0PSIyMyIgdmlld0JveD0iMCAwIDIzIDIzIj4KICAgIDxwYXRoIGZpbGw9IiM5QkE1QUYiIGZpbGwtcnVsZT0iZXZlbm9kZCIgZD0iTTExLjUgMjNDNS4xNDkgMjMgMCAxNy44NTEgMCAxMS41UzUuMTQ5IDAgMTEuNSAwIDIzIDUuMTQ5IDIzIDExLjUgMTcuODUxIDIzIDExLjUgMjN6bS0xLjIxMy0xMEgxN3YtM0g2djNoNC4yODd6Ii8+Cjwvc3ZnPgo=";